import React from 'react';
import PropTypes from 'prop-types';
import { BulkSelectionContext } from './BulkSelection';
export const BulkSelectionConsumer = props => {
    return (React.createElement(BulkSelectionContext.Consumer, null, context => {
        return props.children(context);
    }));
};
BulkSelectionConsumer.propTypes = {
    children: PropTypes.any,
    consumerCompName: PropTypes.string,
    providerCompName: PropTypes.string,
};
BulkSelectionConsumer.defaultProps = {
    consumerCompName: 'BulkSelectionConsumer',
    providerCompName: 'BulkSelection',
};
//# sourceMappingURL=BulkSelectionConsumer.js.map